import React from "react";
import PropTypes from "prop-types";

export const Logo = ({
  text = "LOGO",
  logoUrl,
  alt = "Logo",
  className = "",
  imageClassName = "h-8 w-auto",
  onClick
}) => {
  return (
    <div className={`flex items-center cursor-pointer ${className}`} onClick={onClick}>
      {logoUrl ? (
        <img src={logoUrl} alt={alt} className={imageClassName} />
      ) : (
        <div className="text-gray-500 font-normal tracking-wider text-sm">
          {text}
        </div>
      )}
    </div>
  );
};

Logo.propTypes = {
  text: PropTypes.string,
  logoUrl: PropTypes.string,
  alt: PropTypes.string,
  className: PropTypes.string,
  imageClassName: PropTypes.string,
};
